<template>
  <div class="img">
    <v-img src="@/assets/img/graphics.png"></v-img>
  </div>
</template>

<script>

export default {
  name: 'RegistrationImg',
  components: {
  },
};
</script>

<style scoped>
.img {
  max-width: 100%;
  text-align: center;
  width: 100%;
}
</style>
